import React,{useReducer,useEffect} from 'react';
import { BrowserRouter,Routes,Route,Navigate } from 'react-router-dom';
import { AuthContext } from '../auth/AuthContext';
import { authReducer } from '../auth/authReducer';

import { Home } from '../Components/Home/Home';
import { Directory } from '../Components/Directory/Directory';
import { Nube } from '../Components/Nube/Nube';
import { Productividad } from '../Components/Productividad/Productividad';
import { Actividades } from '../Components/Actividad/Actividades';
import { Configuracion } from '../Components/Config/Configuracion';

import { Navbar } from '../Components/Navbar/Navbar';
import { Asidebar } from '../Components/Asidebar/Asidebar';
import { Login } from '../views/Login/Login';

import { ThemeProvider } from 'react-jss';

import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';

import { showAlert } from '../reducers/appReducer';


const init = () => {
    const dataStorage = JSON.parse(localStorage.getItem("userAryaAgents"));
  
    if (!dataStorage) return { logged: false };

    return JSON.parse(localStorage.getItem("userAryaAgents"));
};

const ProtectedRoute = ({
    usuario,
    redirectPath = "/login",
    children,
}) => {
    if(!usuario.logged){
        return <Navigate to={redirectPath} replace />
    }
    return children;
}

export const DashboardRoutes = ({initData}) => {

    const globalState = useSelector( (state) => state.agents );
    const dispatchGlobal = useDispatch();

    const { toastAlert } = globalState;

    // console.log(globalState)

    const[usuario,dispatch] = useReducer(authReducer,{},init);

    const theme = {
        // colorPrimary: initData.background_primario
        colorPrimary: '#006DAA'
    }
    
    useEffect(() => {
        if(toastAlert.show){
            toast.success( (e) => (
                <p className="mb-0">{toastAlert.message}</p>
            ),{
            duration: 2000
            });
            dispatchGlobal( showAlert( { 
                show: false, 
                message: ''
            } ) )
        }
    },[toastAlert.show]);

    if(initData.background_primario===undefined) return false;

    return (
        <React.Fragment>
            <AuthContext.Provider value={{ usuario,dispatch }}>
                <ThemeProvider theme={theme}> 
                    <BrowserRouter>

                        <Routes>
                            <Route path="/login" element={<Login />} />
                        </Routes>

                        <Routes>
                            <Route 
                            path="/home"
                            element={
                                <ProtectedRoute usuario={usuario}>
                                    <Navbar initData={initData} />
                                    <Asidebar initData={initData} />
                                    <Home />
                                </ProtectedRoute>
                            }
                            />
                            <Route 
                            path="/directorio"
                            element={
                                <ProtectedRoute usuario={usuario}>
                                    <Navbar initData={initData} />
                                    <Asidebar initData={initData} />
                                    <Directory /> 
                                </ProtectedRoute>
                            }
                            />
                            <Route 
                            path="/nube"
                            element={
                                <ProtectedRoute usuario={usuario}>
                                    <Navbar initData={initData} />
                                    <Asidebar initData={initData} />
                                    <Nube />
                                </ProtectedRoute>
                            }
                            />
                            <Route 
                            path="/productividad"
                            element={
                                <ProtectedRoute usuario={usuario}>
                                    <Navbar initData={initData} />
                                    <Asidebar initData={initData} />
                                    <Productividad />
                                </ProtectedRoute>
                            }
                            />
                            <Route 
                            path="/actividad"
                            element={
                                <ProtectedRoute usuario={usuario}>
                                    <Navbar initData={initData} />
                                    <Asidebar initData={initData} />
                                    <Actividades />
                                </ProtectedRoute>
                            }
                            />
                            <Route 
                            path="/configuracion"
                            element={
                                <ProtectedRoute usuario={usuario}>
                                    <Navbar initData={initData} />
                                    <Asidebar initData={initData} />
                                    <Configuracion />
                                </ProtectedRoute>
                            }
                            />
                        </Routes>

                        </BrowserRouter>
                </ThemeProvider>
            </AuthContext.Provider>
        </React.Fragment>
    )
}
